import { all } from 'redux-saga/effects';
import { getNetworkAuditsSaga, runNetworkAuditSaga } from './network-audits.action';

export const networkAuditsSaga = function* () {
  yield all([getNetworkAuditsSaga(), runNetworkAuditSaga()]);
};

export { getNetworkAudits, runNetworkAudit } from './network-audits.action';
export { networkAuditsReducer } from './network-audits.reducer';
